import axios from 'axios';

import { IPointsOfferLocation } from '@/shared/model/points-offer-location.model';

const baseApiUrl = 'api/points-offer-locations';

export default class PointsOfferLocationService {
  public find(id: number): Promise<IPointsOfferLocation> {
    return new Promise<IPointsOfferLocation>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IPointsOfferLocation): Promise<IPointsOfferLocation> {
    return new Promise<IPointsOfferLocation>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IPointsOfferLocation): Promise<IPointsOfferLocation> {
    return new Promise<IPointsOfferLocation>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
